export default () => ({
  el: undefined,
  gridId: undefined,
  endpoint: undefined,
  sortColumn: undefined,
  sortDirection: undefined,
  init() {
    mrp.log(`RxDataGridSort init`);
    this.el = this.$el;
    this.gridId = this.el.getAttribute("data-grid-id");
    this.endpoint = this.el.getAttribute("data-endpoint");
    this.sortColumn = this.el.getAttribute("data-sort-column");
    this.sortDirection = this.el.getAttribute("data-sort-direction");
  },
  click(evt) {
    this.el.setAttribute("disabled", "");
    const indicator = document.getElementById(
      `loading-${evt.currentTarget.id}`
    );
    indicator.classList.add("sort-indicator-request");
    if (this.sortDirection === "NotSorted") {
      this.sortDirection = "Ascending";
    } else if (this.sortDirection === "Ascending") {
      this.sortDirection = "Descending";
    } else {
      this.sortDirection = "NotSorted";
    }
    const obj = {
      column: this.sortColumn,
      direction: this.sortDirection,
    };
    const sortString = `sort=${encodeURIComponent(JSON.stringify(obj))}`;
    sessionStorage.setItem(`${this.gridId}-sort`, sortString);
    const filter = sessionStorage.getItem(`${this.gridId}-filter`) ?? "";
    const context = sessionStorage.getItem(`${this.gridId}-context`) ?? "";
    let path = "";
    const useInfiniteScroll = this.el.getAttribute("data-use-infinite-scroll");
    if (useInfiniteScroll === "true") {
      path = `${this.endpoint}/1?focus=${evt.currentTarget.id}&${sortString}&${filter}&${context}`;
    } else {
      let page = sessionStorage.getItem(`${this.gridId}-page`) ?? "";
      if (page.trim() === "") {
        page = "1";
      }
      path = `${this.endpoint}/${page}?focus=${evt.currentTarget.id}&${sortString}&${filter}&${context}`;
    }
    htmx
      .ajax("GET", path, {
        target: `#${this.gridId}-data-grid`,
        swap: "outerHTML",
      })
      .then(() => {
        indicator.classList.remove("sort-indicator-request");
      });
  },
});
